import { useContext } from "react"
import StateOfTreeContext from "../context/StateOfTreeContext"

const useStateOfTree = () => {
    return useContext(StateOfTreeContext);
}

export default useStateOfTree